"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// src/components/table/StyledTable.tsx
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
var OptionMenu_1 = __importDefault(require("./OptionMenu"));
var ColumnControllerUI_1 = __importDefault(require("./ColumnControllerUI"));
var TableCell_1 = require("@mui/material/TableCell");
var StyledTablePagination = (0, system_1.styled)(material_1.TablePagination)(function (_a) {
    var theme = _a.theme;
    return ({
        bottom: 0,
        width: "98%",
        zIndex: 100,
        backgroundColor: "white",
        textAlign: "right",
        fontSize: "0.68rem",
        padding: "2px 0",
        "& .MuiTablePagination-toolbar": {
            padding: "0 2px",
            minHeight: "20px",
        },
        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-input, & .MuiTablePagination-displayedRows": {
            fontSize: "0.68rem",
            margin: "0 1px",
        },
        "& .MuiTablePagination-select": {
            padding: "0.1px",
            fontSize: "0.68rem",
        },
        "& .MuiIconButton-root": {
            padding: "1px",
        },
        "& .MuiButtonBase-root .MuiMenuItem-root": {
            fontSize: "10px",
        },
    });
});
var scrollbarStyles = (0, system_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* Custom scrollbar styles */\n  &::-webkit-scrollbar {\n    width: 10px; /* Width of the scrollbar */\n  }\n\n  &::-webkit-scrollbar-track {\n    background: blue; /* Color of the scrollbar track */\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: red; /* Color of the scrollbar thumb */\n    border-radius: 10px; /* Curved thumb */\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: darkred; /* Darker thumb on hover */\n  }\n"], ["\n  /* Custom scrollbar styles */\n  &::-webkit-scrollbar {\n    width: 10px; /* Width of the scrollbar */\n  }\n\n  &::-webkit-scrollbar-track {\n    background: blue; /* Color of the scrollbar track */\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: red; /* Color of the scrollbar thumb */\n    border-radius: 10px; /* Curved thumb */\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: darkred; /* Darker thumb on hover */\n  }\n"])));
var StyledTable = function (_a) {
    var _b;
    var rows = _a.rows, columns = _a.columns, heading = _a.heading, actionSelector = _a.actionSelector, page = _a.page, setPage = _a.setPage, rowsPerPage = _a.rowsPerPage, setRowsPerPage = _a.setRowsPerPage, handleChangePage = _a.handleChangePage, handleChangeRowsPerPage = _a.handleChangeRowsPerPage, optionsObject = _a.optionsObject, rowSelector = _a.rowSelector, rowsCount = _a.rowsCount, actionText = _a.actionText, _c = _a.actionDisabled, actionDisabled = _c === void 0 ? false : _c, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d, visibleColumns = _a.visibleColumns, setVisibleColumns = _a.setVisibleColumns, noCustomizeColumn = _a.noCustomizeColumn, onSortModelChange = _a.onSortModelChange, sortModel = _a.sortModel, frontendSort = _a.frontendSort, containerHeight = _a.containerHeight, _e = _a.paginationMargin, paginationMargin = _e === void 0 ? null : _e, _f = _a.isEditable, isEditable = _f === void 0 ? false : _f, currentRow = _a.currentRow, setCurrentRow = _a.setCurrentRow, setRows = _a.setRows, themeMode = _a.themeMode;
    var emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
    var handleSort = function (renderName) {
        var isAsc = sortModel.field === renderName && sortModel.direction === "asc";
        var newSortModel = {
            field: renderName,
            direction: isAsc ? "desc" : "asc",
        };
        onSortModelChange(newSortModel);
    };
    var tableContainerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (tableContainerRef.current) {
            tableContainerRef.current.scrollTop = 0;
        }
    }, [rows, page]);
    var tableContainerWidth = columns.length > 10 ? "72vw" : "auto";
    var StyledTableCell = (0, react_1.memo)((0, system_1.styled)(material_1.TableCell)(function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = {},
            _b["&.".concat(TableCell_1.tableCellClasses.head)] = {
                backgroundColor: themeMode === "dark" ? "#302d4c" : "#e9e8ea",
                color: themeMode === "dark" ? "white" : "black",
                paddingRight: theme.spacing(0.5),
                position: "relative",
                textAlign: "center",
                fontSize: "0.85rem",
                width: tableContainerWidth,
                margin: "0 auto",
            },
            _b["&.".concat(TableCell_1.tableCellClasses.body)] = {
                fontSize: 14,
                color: themeMode === "dark" ? "white" : "black",
                textAlign: "center",
            },
            _b);
    }));
    var StyledTableRow = (0, react_1.memo)((0, system_1.styled)(material_1.TableRow)(function (_a) {
        var theme = _a.theme;
        return ({
            "&:nth-of-type(odd)": {
                backgroundColor: themeMode === "dark" ? "#242243" : "#ffffff",
            },
            "&:nth-of-type(even)": {
                backgroundColor: themeMode === "dark" ? "#242243" : "#ffffff",
            },
            "&:last-child td, &:last-child th": {
                border: 0,
            },
            "&:hover": {
                backgroundColor: themeMode === "dark" ? "#151138" : "#e0e0e5 !important",
            },
        });
    }));
    var StickyTableHead = (0, react_1.memo)((0, system_1.styled)(material_1.TableHead)(function (_a) {
        var theme = _a.theme;
        return ({
            position: "sticky",
            top: 0,
            backgroundColor: themeMode === "dark" ? "#302d4c" : "#e0e0e5",
            color: "#FFFFFF",
            zIndex: 100,
            "& .MuiTableCell-root": {
                padding: "0.4rem",
                fontSize: "0.85rem",
                fontWeight: "bold",
            },
        });
    }));
    var pointerCursorStyle = {
        cursor: "pointer",
    };
    var getCurrentRowIndex = function (rowIndex) {
        if (page === 1) {
            return rowIndex;
        }
        else {
            return rowIndex + page * rowsPerPage;
        }
    };
    var handleRowClick = function (rowIndex) {
        setCurrentRow && setCurrentRow(getCurrentRowIndex(rowIndex));
    };
    var handleCellChange = function (e, rowIndex, columnName) {
        var newData = __spreadArray([], rows, true);
        newData[rowIndex][columnName] = e.target.innerText;
        setRows(newData);
    };
    return (react_1.default.createElement("div", null, isLoading ? (react_1.default.createElement("div", null, "Loading...")) : (react_1.default.createElement(react_1.default.Fragment, null,
        !noCustomizeColumn && (react_1.default.createElement(material_1.Grid, { container: true, sx: {
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
            } },
            react_1.default.createElement(ColumnControllerUI_1.default, { columns: columns, visibleColumns: visibleColumns, setVisibleColumns: setVisibleColumns, themeMode: themeMode }))),
        react_1.default.createElement(material_1.TableContainer, { id: "customTableContainer", style: {
                borderRadius: "1rem",
                maxHeight: containerHeight,
                overflow: "auto",
                width: tableContainerWidth,
                margin: "0 auto",
                // borderRadius: "20px",
                scrollbarWidth: "thin",
                scrollBehavior: "smooth",
                WebkitOverflowScrolling: "touch",
                // WebkitScrollbarWidth: "thin",
                // "&::-webkit-scrollbar": {
                //   width: "10px",
                // },
                scrollbarColor: themeMode === "light" ? "#504e67 #c2c2c2" : "#cac9d4 #312e4d",
                // "&::-webkit-scrollbar": {
                //   width: "10px",
                // },
                // "&::-webkit-scrollbar-track": {
                //   background: themeMode === "light" ? "#c2c2c2" : "#312e4d",
                //   borderRadius: "20px",
                // },
                // "&::-webkit-scrollbar-thumb": {
                //   background: themeMode === "light" ? "#504e67" : "#cac9d4",
                //   borderRadius: "10px",
                // },
                // "&::-webkit-scrollbar-thumb:hover": {
                //   background: themeMode === "light" ? "#3e3d55" : "#b1b0c7",
                // },
                // "html::-webkit-scrollbar": {
                //   width: "10px",
                // },
                // "html::-webkit-scrollbar-thumb": {
                //   background: themeMode === "light" ? "#504e67" : "#cac9d4",
                // },
                // "html::-webkit-scrollbar-hover": {
                //   background: themeMode === "light" ? "#3e3d55" : "#b1b0c7",
                // },
                // "html::-webkit-scrollbar-track": {
                //   background: themeMode === "light" ? "#c2c2c2" : "#312e4d",
                // },
            } },
            heading && (react_1.default.createElement(material_1.Typography, { variant: "h5", sx: { justifyContent: "center", mb: "5px" } }, heading)),
            react_1.default.createElement("div", { style: { paddingRight: ".2rem", borderRadius: "5rem" } },
                react_1.default.createElement(material_1.Table, { style: { overflowX: "auto", width: "100%" } },
                    react_1.default.createElement(StickyTableHead, null,
                        react_1.default.createElement(StyledTableRow, null, columns
                            .filter(function (col) { return visibleColumns.includes(col.renderName); })
                            .map(function (column, index) { return (react_1.default.createElement(StyledTableCell, { key: column.renderName },
                            column.headerName,
                            frontendSort && (react_1.default.createElement(material_1.TableSortLabel, { active: sortModel.field === column.renderName, direction: sortModel.field === column.renderName
                                    ? sortModel.direction
                                    : "asc", onClick: function () { return handleSort(column.renderName); }, style: {
                                    position: "absolute",
                                    right: 0,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                } })))); }))),
                    react_1.default.createElement(material_1.TableBody, null, (_b = (rowsPerPage > 0
                        ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : rows)) === null || _b === void 0 ? void 0 : _b.map(function (row, rowIndex) { return (react_1.default.createElement(StyledTableRow, { key: rowIndex, sx: rowSelector ? pointerCursorStyle : {} }, columns
                        .filter(function (column) {
                        return visibleColumns.includes(column.renderName);
                    })
                        .map(function (column, columnIndex) {
                        var _a, _b, _c, _d, _e, _f;
                        return (react_1.default.createElement(react_1.default.Fragment, null,
                            !column.type &&
                                (isEditable ? (react_1.default.createElement(StyledTableCell, { key: "".concat(rowIndex, "-").concat(columnIndex), sx: { textAlign: "justify" }, contentEditable: isEditable, suppressContentEditableWarning: isEditable, onBlur: function (e) {
                                        return handleCellChange(e, rowIndex, column.renderName);
                                    }, onClick: true
                                        ? function () { return handleRowClick(rowIndex); }
                                        : null }, row[column.renderName] &&
                                    ((_a = row[column.renderName]) === null || _a === void 0 ? void 0 : _a.length) > 20
                                    ? (_c = (_b = row[column.renderName]) === null || _b === void 0 ? void 0 : _b.split(",")) === null || _c === void 0 ? void 0 : _c.join("\n")
                                    : row[column.renderName])) : (react_1.default.createElement(StyledTableCell, { key: "".concat(rowIndex, "-").concat(columnIndex), sx: { textAlign: "justify" }, onClick: function () { return handleRowClick(rowIndex); } }, row[column.renderName] &&
                                    ((_d = row[column.renderName]) === null || _d === void 0 ? void 0 : _d.length) > 20
                                    ? (_f = (_e = row[column.renderName]) === null || _e === void 0 ? void 0 : _e.split(",")) === null || _f === void 0 ? void 0 : _f.join("\n")
                                    : row[column.renderName]))),
                            column.type &&
                                (function () {
                                    switch (column.type) {
                                        case "select":
                                            return (react_1.default.createElement(StyledTableCell, null,
                                                react_1.default.createElement(material_1.Button, { variant: "contained", color: "secondary", onClick: function () { return actionSelector(row); }, disabled: actionDisabled }, actionText !== null && actionText !== void 0 ? actionText : "Select")));
                                        case "menu":
                                            return (react_1.default.createElement(StyledTableCell, null,
                                                react_1.default.createElement(OptionMenu_1.default, { optionsObject: optionsObject, row: row })));
                                        case "action":
                                            return (react_1.default.createElement(StyledTableCell, { key: "".concat(rowIndex, "-").concat(columnIndex), sx: { textAlign: "justify" } }, row[column.renderName] === "string" &&
                                                row[column.renderName].length > 20
                                                ? row[column.renderName]
                                                    .split(",")
                                                    .join("\n")
                                                : row[column.renderName]));
                                        default:
                                            return;
                                    }
                                })()));
                    }))); }))))),
        react_1.default.createElement("div", { style: {
                display: "flex",
                justifyContent: "flex-end",
                width: tableContainerWidth,
                margin: "0 auto",
                color: themeMode === "dark" ? "white" : "black",
                marginTop: paginationMargin
                    ? "calc(".concat(containerHeight, " - ").concat(paginationMargin, ")")
                    : "10px",
                backgroundColor: themeMode === "dark" ? "#302d4c" : "#e9e8ea",
            } },
            react_1.default.createElement(StyledTablePagination, { rowsPerPageOptions: [10, 25, 50, 100], sx: {
                    backgroundColor: themeMode === "dark" ? "#302d4c" : "#e9e8ea",
                    color: themeMode === "dark" ? "white" : "black",
                    borderBottom: themeMode === "dark"
                        ? "2px solid #302d4c"
                        : "2px solid #e9e8ea",
                    "& .MuiTablePagination-toolbar": {
                        padding: "0 2px",
                        minHeight: "20px",
                    },
                    "& .MuiTablePagination-selectLabel, & .MuiTablePagination-input, & .MuiTablePagination-displayedRows": {
                        fontSize: "0.68rem",
                        margin: "0 1px",
                    },
                    "& .MuiTablePagination-select": {
                        padding: "0.1px",
                        fontSize: "0.68rem",
                    },
                    "& .MuiIconButton-root": {
                        padding: "1px",
                    },
                    "& .MuiMenuItem-root": {
                        fontSize: "10px",
                    },
                }, colSpan: columns.length, count: rowsCount !== null && rowsCount !== void 0 ? rowsCount : rows.length, labelDisplayedRows: function (_a) {
                    var from = _a.from, to = _a.to, count = _a.count, page = _a.page;
                    return "Page ".concat(page + 1, " of ").concat(Math.ceil(count / rowsPerPage)).concat("\u00A0\u00A0\u00A0\u00A0", "| ").concat("\u00A0\u00A0\u00A0\u00A0", " Records: ").concat(count);
                }, rowsPerPage: rowsPerPage, page: page, slotProps: {
                    select: {
                        "aria-label": "rows per page",
                        MenuProps: {
                            PaperProps: {
                                sx: {
                                    backgroundColor: themeMode === "dark" ? "#302d4c" : "#e9e8ea",
                                    color: themeMode === "dark" ? "white" : "black",
                                },
                            },
                            MenuListProps: {
                                sx: {
                                    "& .MuiMenuItem-root": {
                                        backgroundColor: themeMode === "dark" ? "#242243" : "#e0e0e5",
                                        color: themeMode === "dark" ? "white" : "black",
                                        "&:hover": {
                                            backgroundColor: themeMode === "dark" ? "#151138" : "#d0d0d5",
                                        },
                                    },
                                },
                            },
                        },
                    },
                    actions: {
                        firstButton: {
                            sx: {
                                display: "block",
                            },
                        },
                        lastButton: {
                            sx: {
                                display: "block",
                            },
                        },
                    },
                }, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage }))))));
};
exports.default = StyledTable;
var templateObject_1;
